import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { getCourseRoster } from '../core/lms';

// state.gradebook.roster can be a search/pagination-scoped subset of the
// class. Anything that needs the full class roster (e.g. a "switch student"
// list or an assign to "everyone" option) must fetch it independently rather
// than reading that shared state. Backed by react-query so concurrent
// callers (e.g. the gradebook toolbar and an open ISG) share one request
// and one cache entry instead of each fetching their own copy.
export function useFullRoster(courseId) {
  // If the full-roster fetch is still loading or has failed, fall back to
  // the (possibly search/page-scoped) roster already in Redux
  const scopedRoster = useSelector((state) => state.gradebook.roster);

  const { data } = useQuery({
    queryKey: ['courseRoster', courseId],
    queryFn: () => getCourseRoster(courseId),
    enabled: !!courseId,
  });

  return data ?? scopedRoster ?? [];
}
